import { isIsoDate } from '../../validation/is-iso-date.function';
import { isIsoDateTime } from '../../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../../validation/is-iso-date-time-tz.function';
import { getTimeOffset } from '../../get/get-time-offset.function';
import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { constructDate } from '../../helper/construct-date.function';
import { getLastDayOfMonth } from '../../helper/last-day-of-month.function';

function pad(n: number): string { return n < 10 ? `0${n}` : `${n}`; }



/**
 * Returns the end of the month for the given ISO input.
 * - Date-only (YYYY-MM-DD) -> 'YYYY-MM-DD' (last day of month)
 * - Date-time without tz -> 'YYYY-MM-DDT23:59:59.999'
 * - Date-time with tz -> 'YYYY-MM-DDT23:59:59.999Z|±HH:MM'
 */
export function endOfMonth<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (deconstructed._type !== 'date' && deconstructed._type !== 'dateTime' && deconstructed._type !== 'dateTimeTz') {
    throw new Error('endOfMonth: invalid ISO date/time string');
  }
  deconstructed.day = getLastDayOfMonth(deconstructed.year, deconstructed.month);
  if (deconstructed._type !== 'date') {
    deconstructed.hours = 23;
    deconstructed.minutes = 59;
    deconstructed.seconds = 59;
    deconstructed.milliseconds = 999;
  }
  return constructDate(deconstructed) as unknown as T;
}

